// depends on global PIXI

/**
 * @file button.js
 * @desc This module contains Button class definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */

(/** @lends <global> */function (global) {
    'use strict';

    /**
     * Constructs button object.
     * @class
     * @constructor
     * @param {Object} normalTexture Normal state texture
     * @param {Object} overredTexture Over state texture
     * @param {Object} pressedTexture Pressed state texture
     * @param {Object} disabledTexture Disabled state texture
     * @name Button
     * @classdesc This is a GUI component.
     * @extends {PIXI.Sprite}
     *
     * @example
     * var normalStateTexture = PIXI.utils.TextureCache["normal.png"];
     * var pressedStateTexture = PIXI.utils.TextureCache["pressed.png"];
     * var overStateTexture = PIXI.utils.TextureCache["over.png"];
     * var disabledStateTexture = PIXI.utils.TextureCache["disabled.png"];
     *
     * var button = new Button(normalStateTexture, overStateTexture, pressedStateTexture, disabledStateTexture);
     * scene.addChild(button);
     * button.callback = function () {
     *   console.log("CLICK!");
     * };
     * */
    var Button = function(normalTexture, overredTexture, pressedTexture, disabledTexture, hitArea) {

        PIXI.Sprite.call(this, normalTexture);

        this.interactive = true;
        this.callback = null;

        this._normalTexture = normalTexture;
        this._disabledTexture = disabledTexture;

        this.captured = false;

        this.on('pointerup', function (event) {
            if (this.captured) {
                this.captured = false;
            }
            this.texture = normalTexture;
            if (this.callback) {
                this.callback();
            }
        }.bind(this));

        this.on('pointerover', function(event) {
            this.texture = overredTexture;
        }.bind(this));

        this.on('pointerout', function(event) {
            this.texture = normalTexture;
        }.bind(this));

        this.on('pointerdown',  function(event) {
            if (event.data.originalEvent.button != null && event.data.originalEvent.button != 0) {
                return;
            }
            this.texture = pressedTexture;
            this.captured = true;
        }.bind(this));

        this.on('pointerupoutside', function (event) {
            this.texture = normalTexture;
            this.captured = false;
        }.bind(this));

        if (hitArea) {
            var lb = this.getBounds();
            switch (hitArea) {
                case 'ellipse':
                    this.hitArea = new PIXI.Ellipse(0, lb.height / 2, lb.width/2, lb.height / 2);
                    break;
                case 'circle' :
                    this.hitArea = new PIXI.Circle(lb.height / 2, lb.width/2, Math.min(lb.height / 2, lb.width/2));
                    break;

            }
        }
    };

    Button.prototype = Object.create(PIXI.Sprite.prototype);
    Button.prototype.constructor = Button;

    Object.defineProperties(Button.prototype, {

        /**
         * Button enabled property.
         * @memberOf Button
         * */
        enabled: {

            get: function () {
                return this.interactive;
            },
            set: function (value) {
                if (this.interactive && !value)
                {
                    this.texture = this._disabledTexture;
                }
                else if (!this.interactive && value)
                {
                    this.texture = this._normalTexture;
                }
                this.interactive = value;
            },
            enumerable: true
        }
    });

    global.Button = Button;
}(typeof module === 'object' && module.exports || this));



//////////////////
// WEBPACK FOOTER
// ./src/library/button.js
// module id = 16
// module chunks = 0